import { RelatedMatchProps, LiveTimer } from '@nf/types/live-timer';
import { useTranslations } from 'next-intl';
import { useState, useRef, useEffect, use } from 'react';

const parseEvent = (gst: number, isLive: boolean, tsp: boolean, sportId: number, tsta: boolean): string => {
	const valueIndex = typeof gst === 'number' ? gst : 0;
	let eventLabel = [
		undefined,
		'lbl_PRC',
		'lbl_PPen',
		'lbl_VAR',
		'lbl_Pen',
		'lbl_Inj',
		'lbl_SuddenDeath'
	][valueIndex];
	if (tsp && isLive) {
		switch (sportId) {
			case 2:
			case 3:
			case 4:
			case 6:
			case 47:
			case 49:
			case 51:
			case 45:
			case 18:
			case 48:
				eventLabel = 'lbl_TOUT';
		}
	}
	if (isLive && sportId === 1 && !tsp && tsta) {
		return 'lbl_TOUT';
	}

	if (isLive && [3, 4, 28, 47].includes(sportId)) {
		if (tsp) {
			return 'lbl_TOUT';
		}
		return '';
	}

	return eventLabel || '';
};

const parseMatchStatus = (sportId: number, isLive: boolean, tsp: boolean, showTime: string, tsta: boolean, ISS?: number): string => {
	if (!isLive) {
		return '';
	} else if (isLive && [3, 4, 28, 47].includes(sportId) && tsta) {
		return 'lbl_live';
	} else if (sportId === 1 && tsp) {
		return 'Ref_IR';
	} else if (sportId === 9) {
		if (tsp && isLive) {
			return 'lbl_TOUT';
		}
		return 'Ref_live';
	} else if ([55, 56, 99].includes(sportId)) {
		return '';
	} else if (sportId === 50) {
		if (tsp) {
			return 'lbl_Crckt_Stumps';
		} else if (showTime === 'Ref_htime') {
			return 'lbl_InnsBreak';
		} else {
			return showTime || '';
		}
	} else if (sportId === 2) {
		return ConvertTimeLanguage(showTime ?? '', true);
	} else if (sportId === 43) {
		return (ISS === 0) ? 'lbl_Status_InPlay' : 'Ref_live';
	} else {
		switch (showTime) {
			case 'Ref_live':
				return 'lbl_live';
			default:
				return showTime || '';
		}
	}
};
const checkOtherMatchStatus = (sportId: number, isLive: boolean, tsp: boolean): string => {
	if (tsp && isLive) {
		switch (sportId) {
			case 5:
			case 8:
			case 45:
				return 'Rain';
			case 7:
				return 'Coffee';
		}
	}
	return '';
}
const parseMatchBeginTime = (gameTime: string, showTime: string, upComingResource: string, GameID: number, esportInplayResource: string): string => {
	const beginTime = new Date(`${gameTime}-04:00`);
	const hours = beginTime.getHours() < 10 ? '0' + beginTime.getHours() : beginTime.getHours();
	const minutes = beginTime.getMinutes() < 10 ? '0' + beginTime.getMinutes() : beginTime.getMinutes();

	if (/<font.*font>/ig.test(showTime)) {

		const displayTimer = (GameID === 43 && showTime.includes('PLAY')) ? esportInplayResource : upComingResource;

		return `
			<div class="match-live">
				<span class="text-highlight">${displayTimer}</span> ${hours}:${minutes}
			</div>
		`;
	}
	return `<div class="match-time">${(beginTime.getMonth() + 1) < 10 ? '0' + (beginTime.getMonth() + 1) : beginTime.getMonth() + 1}/${beginTime.getDate() < 10 ? '0' + beginTime.getDate() : beginTime.getDate()}
	${hours}:${minutes}</div>`;
};
const parseCountdownTime = (ltm?: number[]): string => {
	if (!Array.isArray(ltm) || ltm.length < 3) {
		return '';
	}

	const [totalMinutes, beginTimestamp, offsetSeconds] = ltm;
	const currentTime = new Date().getTime();
	let elapsedSeconds = offsetSeconds === 0 ? Math.round(((currentTime - new Date(beginTimestamp).getTime())) / 1000) : offsetSeconds > 0 ? 0 : Math.abs(offsetSeconds);
	if (elapsedSeconds > totalMinutes * 60) {
		elapsedSeconds = 0;
	} else {
		elapsedSeconds = (totalMinutes * 60) - elapsedSeconds;
	}
	const minutes = Math.floor(elapsedSeconds / 60);
	const seconds = elapsedSeconds - (minutes * 60);
	return `${(minutes + 100).toString().substring(1, 3)}:${(seconds + 100).toString().substring(1, 3)}`
};

const ConvertTimeLanguage = (ShowTimeVal: string, onlyheader: boolean) => {
	let ShowTime = ShowTimeVal;
	switch (ShowTime.substring(0, 2)) {
		case '1Q':
			ShowTime = 'lbl_1Q';
			break;
		case '2Q':
			ShowTime = 'lbl_2Q';
			break;
		case '3Q':
			ShowTime = 'lbl_3Q';
			break;
		case '4Q':
			ShowTime = 'lbl_4Q';
			break;
		case '1H':
			ShowTime = 'lbl_1H';
			break;
		case '2H':
			ShowTime = 'lbl_2H';
			break;
		case '1P':
			ShowTime = 'livescoreHeader_1P';
			break;
		case '2P':
			ShowTime = 'livescoreHeader_2P';
			break;
		case '3P':
			ShowTime = 'livescoreHeader_3P';
			break;
		case 'OT':
			ShowTime = 'lbl_OT';
			break;
	}

	if (!onlyheader && ShowTime != ShowTimeVal) {
		ShowTime = ShowTime + ShowTimeVal.substring(2);
	}
	return ShowTime;
}
const checkHasCountdown = (sportId: number, isLive: boolean, ltm?: number[]): boolean => {
	if (!isLive || ![2, 55, 56, 99].includes(sportId)) {
		return false;
	}
	const elapsedSeconds = (Array.isArray(ltm) && ltm.length > 2) ? ltm[2] : null;
	return elapsedSeconds !== null;
};

const checkMatchNeedCountDown = (MaT: string): boolean => {
	return ['t', 'u'].includes(MaT);
}

const parseMatchGameTime = (gameTime: string, isLive: boolean, liveStr: string) => {
	let matchTime = '';
	if (isLive) {
		matchTime = liveStr;
	} else {
		const beginTime = new Date(`${gameTime}-04:00`);
		const hours = beginTime.getHours() < 10 ? '0' + beginTime.getHours() : beginTime.getHours();
		const minutes = beginTime.getMinutes() < 10 ? '0' + beginTime.getMinutes() : beginTime.getMinutes();

		matchTime = `${(beginTime.getMonth() + 1) < 10 ? '0' + (beginTime.getMonth() + 1) : beginTime.getMonth() + 1}/${beginTime.getDate() < 10 ? '0' + beginTime.getDate() : beginTime.getDate()}
		${hours}:${minutes}`;
	}
	return matchTime;
}

const parseMatchCountDownTime = (gameTime: string): string => {
	const currentTime = new Date();
	const beginTime = new Date(`${gameTime}-04:00`);
	const timeDiff = beginTime.valueOf() - currentTime.valueOf();
	const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
	if (timeDiff < 0) {
		return '00:00:00';
	}
	return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
};

const formatTimeDigit = (num: number): string => {
	return num.toString().padStart(2, '0');
};

export const useLiveTimer = (match: RelatedMatchProps): LiveTimer => {
	const { GameID, GST, IsLive, ShowTime, GameTime, ltm, Tsp, Tsta, ISS } = match ?? {};
	const t = useTranslations('General');
	const [event, setEvent] = useState(parseEvent(GST, IsLive, Tsp, GameID, Tsta));
	const [matchStatus, setMatchStatus] = useState(parseMatchStatus(GameID, IsLive, Tsp, ShowTime, Tsta, ISS));
	const [matchBeginTime, setMatchBeginTime] = useState(parseMatchBeginTime(GameTime, ShowTime, t('lbl_LIVE_caps'), GameID, t('lbl_Status_InPlay')));
	const [matchGameTime, setMatchGameTime] = useState(parseMatchGameTime(GameTime, IsLive, t('lbl_live')));
	const [hasCountdown, setHasCountdown] = useState(checkHasCountdown(GameID, IsLive, ltm));
	const [matchNeedCountDown, setMatchNeedCountDown] = useState(checkMatchNeedCountDown(match.MaT));
	const [otherMatchStatus, setOtherMatchStatus] = useState(checkOtherMatchStatus(GameID, IsLive, Tsp));
	const [matchCountDownTime, setMatchCountDownTime] = useState(parseMatchCountDownTime(GameTime));
	const countdownDomRef = useRef<HTMLDivElement>(null);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();
	useEffect(() => {
		setEvent(parseEvent(GST, IsLive, Tsp, GameID, Tsta));
		setMatchStatus(parseMatchStatus(GameID, IsLive, Tsp, ShowTime, Tsta, ISS));
		setOtherMatchStatus(checkOtherMatchStatus(GameID, IsLive, Tsp));
	}, [GST, IsLive, Tsp, ShowTime, ISS]);
	useEffect(() => {
		setMatchBeginTime(parseMatchBeginTime(GameTime, ShowTime, t('lbl_LIVE_caps'), GameID, t('lbl_Status_InPlay')))
	}, [GameTime, ShowTime]);
	useEffect(() => {
		setHasCountdown(checkHasCountdown(GameID, IsLive, ltm));
	}, [IsLive, ltm, event]);
	useEffect(() => {
		setMatchGameTime(parseMatchGameTime(GameTime, IsLive, t('lbl_live')));
	})
	useEffect(() => {
		setMatchNeedCountDown(checkMatchNeedCountDown(match.MaT));
	})
	useEffect(() => {
		if (hasCountdown) {
			if (countdownDomRef.current) {
				countdownDomRef.current.textContent = `${t(ConvertTimeLanguage(ShowTime ?? '', true))} ${parseCountdownTime(ltm)}`;
			}
			if (ltm && ltm[2] == 0) {
				timerRef.current = setInterval(() => {
					if (
						countdownDomRef.current && 
						typeof countdownDomRef.current.textContent === 'string' && 
						countdownDomRef.current.textContent.includes(':')
					) {
						const countdownParts = countdownDomRef.current.textContent.split(' ');
						const timePartIndex = countdownParts.findIndex(part => part.includes(':'));
						const timePart = countdownParts[timePartIndex];

						const [min, sec] = timePart.split(':');
						const totalTime = parseInt(min) * 60 + parseInt(sec);

						let remainingTime = totalTime;
						if (remainingTime > 0) {
							remainingTime--;
						}

						const minutes = Math.floor(remainingTime / 60);
						const seconds = remainingTime % 60;

						countdownDomRef.current.textContent = countdownDomRef.current.textContent.replace(
							timePart, 
							`${formatTimeDigit(minutes)}:${formatTimeDigit(seconds)}`
						);
					}
				}, 1000);
			}
		}
		return () => {
			clearInterval(timerRef.current);
		};
	}, [hasCountdown, ltm, event]);
	useEffect(() => {
		if (matchNeedCountDown) {
			const timer = setInterval(() => {
				setMatchCountDownTime(parseMatchCountDownTime(GameTime));
			}, 1000)
			return () => {
				clearInterval(timer);
			}
		}
	}, [matchNeedCountDown, GameTime]);
	const runtimeResult: LiveTimer = {
		matchBeginTime,
		matchGameTime,
		matchCountDownTime
	};
	if (event) {
		runtimeResult.event = event;
	}
	if (matchStatus) {
		if (matchStatus.match(/lbl_/) || matchStatus.match(/Ref_/)) {
			runtimeResult.matchStatus = t(matchStatus);
		} else {
			const matchShowTime = matchStatus.split(' ');
			runtimeResult.matchStatus = `${t(ConvertTimeLanguage(matchShowTime[0], true))} ${matchShowTime[1]}`;
		}
	}
	if (hasCountdown) {
		runtimeResult.countdownDomRef = countdownDomRef;
	}
	if (otherMatchStatus) {
		runtimeResult.checkOtherMatchStatus = otherMatchStatus;
	}
	return runtimeResult;
};